<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家入驻列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_id"
                    placeholder="商家id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.brand_name"
                    placeholder="品牌"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-select v-model="form.audit_status" placeholder="状态">
                    <el-option
                      v-for="item in audit_status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.is_benchmarking"
                    placeholder="是否标杆商家"
                  >
                    <el-option
                      v-for="item in is_benchmarking"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_level"
                    placeholder="商家等级"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="申请时间">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="审核时间">
                  <el-date-picker
                    v-model="form.audit_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="normal" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="float: right; margin-left: auto; background: #85ce61"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="supply_id"
              label="商家id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_name"
              label="商家名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_city"
              label="城市"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="parent_market_name"
              label="市场"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="market_name"
              label="子市场"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="brand_name"
              label="品牌"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_is_benchmarking"
              label="是否标杆商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_level"
              label="商家等级"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_contact"
              label="联系人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_telephone"
              label="联系方式"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_address"
              label="店铺地址"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="years"
              label="店铺年限"
            ></el-table-column>
            <el-table-column
              prop="supply_img"
              label="店铺实拍图"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.supply_img"
                    :preview-src-list="[scope.row.supply_img]"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="fangle_num"
              label="每月新款数"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="cat"
              label="主营类目"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="styles"
              label="主打风格"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_contact"
              label="历史收款人姓名"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="realname"
              label="身份证姓名"
            ></el-table-column>
            <el-table-column
              width="200"
              align="center"
              prop="idcard"
              label="身份证号码"
            ></el-table-column>
            <el-table-column
              prop="front_id_card"
              label="身份证正面"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.front_id_card"
                    :preview-src-list="[scope.row.front_id_card]"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="back_id_card"
              label="身份证背面"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.back_id_card"
                    :preview-src-list="[scope.row.back_id_card]"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="spply_license"
              label="营业执照"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.spply_license"
                    :preview-src-list="[scope.row.spply_license]"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="license_no"
              label="统一社会信用代码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_cooperation_shop_type"
              label="店铺类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="shop_name"
              label="档口名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="platform_security_amount"
              label="已缴保证金"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="platform_year_amount"
              label="已缴年费"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="申请时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="audit_time"
              label="审核时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="审核人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="audit_desc"
              label="驳回原因"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_cooperation_audit_status"
              label="状态"
            ></el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.audit_status == 1"
                  size="mini"
                  type="text"
                  @click="
                    cooperationAudit(scope.row.cooperation_id, 2, '确定通过？')
                  "
                  >通过</el-button
                >
                <el-button
                  v-if="
                    scope.row.audit_status == 1 || scope.row.audit_status == 4
                  "
                  size="mini"
                  type="text"
                  @click="
                    audit = true;
                    audit_cooperation_id = scope.row.cooperation_id;
                    audit_desc = '';
                  "
                  >驳回</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
          :visible.sync="audit"
          width="30%"
          :close-on-click-modal="false"
          :show-close="false"
          center
        >
          <div style="justify-content: center; display: flex; margin: auto">
            <el-input
              v-model="audit_desc"
              placeholder="请输入驳回原因"
            ></el-input>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="button" @click="audit = false">取消</el-button>
            <el-button type="primary" @click="reject">确认</el-button>
          </div>
        </el-dialog>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import PreviewImage from "../../components/PreviewImage.vue";

export default {
  components: {
    PreviewImage,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      audit: false,
      audit_desc: "",
      audit_cooperation_id: "",
      images: [],
      showbox: false,
      audit_status: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "待审核",
        },
        {
          value: "2",
          label: "已审核",
        },
        {
          value: "3",
          label: "已驳回",
        },
        {
          value: "4",
          label: "申请修改",
        },
      ],
      is_benchmarking: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      logVisible: false,
      resData: {},
      form: {
        audis_tatus: "",
        create_time: this.defaultDate(),
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Supply/cooperationList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      dialogFormVisible: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    reset() {
      this.form = {
        audis_tatus: "",
        create_time: this.defaultDate(),
      };
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    reject() {
      this.$http
        .post("/erp/supply/auditCooperation", {
          cooperation_id: this.audit_cooperation_id,
          audit_status: 3,
          audit_desc: this.audit_desc,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            return this.$message.error(res.data.msg);
          }
          this.audit_desc = "";
          this.audit_cooperation_id = "";
          this.audit = false;
          this.fetchData();
          return this.$message.success("操作成功");
        });
    },
    cooperationAudit(id, status, confirmText) {
      this.$confirm(confirmText, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then((response) => {
          this.loading = true;
          this.$http
            .post("/erp/supply/auditCooperation", {
              cooperation_id: id,
              audit_status: status,
            })
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                return this.$message.error(res.data.msg);
              }
              this.fetchData();
              return this.$message.success("操作成功");
            });
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 15);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
      return [start, end];
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/Cooperation.vue